<template>
    <div class="payment-types-page">
        <div class="container">
            <div class="page-title">
                <h1>{{ paymentPage.page_title }}</h1>
            </div>
            <div class="payment-page-head">
                <div class="page-title-navigation">
                    <ul>
                        <li v-for="item in paymentPage.page_nav"><router-link :to="item.link == '/payment-types' ? '/payment-types' : '/payment-types' + item.link">{{ item.name }}</router-link></li>
                    </ul>
                </div>
            </div>
            <div class="payments-types-content-container"><router-view></router-view></div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'payment-types--page',
        components: {
            formPage,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            paymentPage: 'loadPaymentPage',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.paymentPage != null) {
                next();
            } else {
                store.dispatch('getPaymentPageData').then((response) => {
                    if (response) {
                        next();
                        // next(vm => {
                        //     // vm.$store.commit('removePageLoaderImg');
                        //     setTimeout(() => {
                        //         vm.$parent.$refs.topProgress.done();
                        //     }, 300);
                        // });
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'payment-types';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/payment-page/payment-page.scss';
    @import '@/styles/components/payment-page/respond/payment-page-respond.scss';
</style>